"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const react_custom_scrollbars_2_1 = __importDefault(require("react-custom-scrollbars-2"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const clsx_1 = __importDefault(require("clsx"));
const useRightsholderReset_1 = __importDefault(require("@App/services/useRightsholderReset"));
const RightsholderTray = () => {
    const { popupStore, rightsholderStore, rightsholderSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const resetRightsholder = (0, useRightsholderReset_1.default)();
    const allDoneRightsHolders = rightsholderSearchStore.rightsholders;
    return (react_1.default.createElement("div", { className: "rightsholders-tray-component" },
        react_1.default.createElement(react_custom_scrollbars_2_1.default, null,
            react_1.default.createElement("div", { className: "rightsholders-tray-list" }, allDoneRightsHolders &&
                allDoneRightsHolders.content.map((item) => {
                    const isCurrentRightsholder = rightsholderStore.optionalCurrentRightsholderId === item.ipId;
                    const divClassNames = (0, clsx_1.default)('rightsholders-card', isCurrentRightsholder && 'current');
                    return (react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.summary(item.ipId), key: item.ipId, onClick: () => {
                            if (!isCurrentRightsholder) {
                                resetRightsholder();
                            }
                            popupStore.setRightsholderTrayState(false);
                        } },
                        react_1.default.createElement("div", { className: divClassNames, key: item.ipId },
                            react_1.default.createElement("img", { src: common_1.ICONS.account, alt: "Accounts" }),
                            react_1.default.createElement("div", { className: 'name-block' },
                                react_1.default.createElement("p", { className: "small bold", title: item.name }, item.name)))));
                }))),
        react_1.default.createElement("div", { className: "closer", onMouseDown: () => popupStore.setRightsholderTrayState(false) })));
};
exports.default = (0, mobx_react_1.observer)(RightsholderTray);
